import RoundedButton from 'components/RoundedButton';
import { ASSET_PREFIX } from 'utils/constants';
import PopupWithDimmedBackground from 'components/PopupWithDimmedBackground';

const DrawDaysPopup = ({ onClose }) => (
  <PopupWithDimmedBackground icon={`${ASSET_PREFIX}/images/enter/draw-days-popup-icon.svg`} onClose={onClose}>
    <div className="grid gap-2em fullWidth">
      <div>
        <p className="xlarge xbold">
          Draw days
        </p>
      </div>

      <div>
        <p className="medium">
          Winning numbers are drawn every Friday & Tuesday. Choose whether you want to be entered into the Tuesday Draw, the Friday Draw, or both.
        </p>

        <p className="medium">
          The two draws are identical and you’ll be entered with the same numbers and amount of entries.
        </p>
      </div>

      <RoundedButton className="fullWidth" onClick={onClose}>
        Got it
      </RoundedButton>
    </div>
  </PopupWithDimmedBackground>
);

export default DrawDaysPopup;
